var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-box-container"},[_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.$t(_vm.message)))]),(_vm.isClosable)?_c('CloseIcon',{staticClass:"close-icon",attrs:{"viewBox":"0 0 16 16"},on:{"click":_vm.closeErrorBox}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }